// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { getViewportInfo } from '@tcp/core/src/utils';
import Button from '../../../atoms/Button';
import withStyles from '../../../hoc/withStyles';
import style from '../styles/FilterAccordion.style';

export function CheckClickedPanel(filterName, selectedFilterOption, panelHidden, panelBlock) {
  return filterName?.toLowerCase() === selectedFilterOption?.toLowerCase()
    ? panelBlock
    : panelHidden;
}

export const setFilterOption = (selectedFilterOption) => {
  if (selectedFilterOption.toUpperCase().includes('FILTER') || selectedFilterOption.length === 0) {
    return 'Color';
  }
  return selectedFilterOption;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const FilterAccordion = (props) => {
  const {
    className,
    children,
    filterName,
    onAccordianClick,
    visibility,
    onClickAccordionScroll,
    selectedFilterOption,
    setChildRefData,
    childRef,
  } = props;
  const panelHidden = 'panel-hidden';
  const panelBlock = 'panel-block';
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    const clickedPanel = CheckClickedPanel(
      filterName,
      selectedFilterOption,
      panelHidden,
      panelBlock
    );
    const displayStatus = clickedPanel || visibility;
    setDisplay(displayStatus);
  }, [filterName, visibility]);

  const filterPositionRef = useRef(null);
  const isDesktop = getViewportInfo()?.isDesktop;
  const trimmedStr = `filter-accordion-${String(filterName)}`?.replace(/\s+/g, '-');
  if (isDesktop === undefined) {
    return null;
  }
  if (isDesktop) {
    return (
      <section className={`${className} filter-accordion-main desktop `} ref={filterPositionRef}>
        <div className="sub-main-division-line">
          <Button
            className={`accordion  ${!visibility ? '' : 'division-button'}`}
            type="button"
            aria-labelledby={`${trimmedStr}`}
            fullWidth
            buttonVariation="variable-width"
            onClick={() => {
              setTimeout(() => {
                if (onAccordianClick) {
                  setChildRefData({ ...childRef, [filterName]: filterPositionRef });
                  onAccordianClick(filterName);
                }
                if (onClickAccordionScroll) {
                  setChildRefData(filterPositionRef);
                  onClickAccordionScroll(filterPositionRef);
                }
              }, 0);
            }}
          >
            <div className="accordion-text">
              <span
                id={`${trimmedStr}`}
                className={`grids heading-accordion filter-label ${
                  visibility ? 'filter-label-expanded' : ''
                }`}
              >
                {filterName}
              </span>
            </div>
          </Button>
          <div className={`panel ${visibility ? panelBlock : panelHidden} division-line-after`}>
            {children}
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className={`${className} filter-accordion-main mobile`} ref={filterPositionRef}>
      <div className="sub-main-division-line mobile">
        <Button
          className={`accordion  ${display === panelHidden ? '' : 'division-button'}`}
          type="button"
          aria-labelledby={`${trimmedStr}`}
          fullWidth
          buttonVariation="variable-width"
          onClick={() => {
            if (display === panelHidden) {
              setDisplay(panelBlock);
              if (onClickAccordionScroll) {
                onClickAccordionScroll(filterPositionRef);
              }
            } else {
              setDisplay(panelHidden);
            }
          }}
        >
          <div className="accordion-text">
            <span
              id={`${trimmedStr}`}
              className={`grids heading-accordion filter-label ${
                display === panelBlock ? 'filter-label-expanded' : ''
              }`}
            >
              {filterName}
            </span>
          </div>
        </Button>
        <div className={`panel ${display} division-line-after`}>{children}</div>
      </div>
    </section>
  );
};

FilterAccordion.propTypes = {
  className: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  children: PropTypes.objectOf({}),
  selectedFilterOption: PropTypes.string,
  onAccordianClick: PropTypes.func,
  visibility: PropTypes.bool,
  onClickAccordionScroll: PropTypes.func,
};
FilterAccordion.defaultProps = {
  children: {},
  selectedFilterOption: '',
  onAccordianClick: () => {},
  visibility: false,
  onClickAccordionScroll: () => {},
};

export default withStyles(FilterAccordion, style);
export { FilterAccordion as FilterAccordionVanilla };
